export default {
  contextTypes: {
    executeAction() {},
  },

  executeAction(RunnerClass, ...params) {
    this.context.executeAction(RunnerClass, ...params);
  },
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/action_mixin.js